// extracted by mini-css-extract-plugin
export default {"wrapper":"UiElapsedTime_wrapper","unit":"UiElapsedTime_unit"};